import React from 'react';
import { Link } from 'react-router';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import data from '../../data/contact';

const Nav = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        <img src={`${BASE_PATH}/images/profile-icon.jpg`} alt="Hernan Picatto" />
      </Link>
      <header>
        <h2>Hernan Picatto</h2>
        <p><a href="mailto:h.picatto@gmail.com">h.picatto@gmail.com</a></p>
      </header>
    </section>

    <section className="blurb">
      <h2>About</h2>
      <p>Hi, I&apos;m Hernan Picatto. I am a data engineer at <a href="https://ascii.ac.at">ASCII</a> and
        a doctoral student in Informatics at <a href="https://www.tuwien.at">TU Wien</a>. I live in Vienna.
        I build web-scale data pipelines and the infrastructure that keeps research reproducible.
      </p>
      <p>Before Vienna I was a software engineer at JPMorgan Chase and an algorithm engineer in Beijing.
        I trained as a political scientist at UCSD, where I studied at <a href="https://gps.ucsd.edu/">GPS</a> and{' '}
        <a href="http://polisci.ucsd.edu/">PoliSci</a>, and I did my degree at <a href="https://ucema.edu.ar">UCEMA</a> in
        Buenos Aires. I also spent almost 3 years at <a href="http://npsglobal.org/">NPS</a> Global Foundation,
        an NGO against the proliferation of nuclear weapons.
      </p>
      <ul className="actions">
        <li>
          {window.location.pathname !== `${BASE_PATH}/resume` ? <Link to="/resume" className="button">Learn More</Link> : <Link to="/about" className="button">About Me</Link>}
        </li>
      </ul>
    </section>

    <section id="footer">
      <ul className="icons">
        {data.map((s) => (
          <li key={s.label}>
            <a href={s.link}>
              <FontAwesomeIcon icon={s.icon} />
            </a>
          </li>
        ))}
      </ul>
      <p className="copyright">&copy; Hernan Picatto <Link to="/">hpicatto.com</Link>.</p>
    </section>
  </section>
);

export default Nav;
